import React, { FunctionComponent, useEffect, useMemo, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { store } from "react-notifications-component"
import { Route, useHistory, useRouteMatch } from "react-router"
import { notificationOptions } from "../../../api/Definitions"
import Loader from "../../../components/Loader/Loader"
import Seo from "../../../components/Seo/Seo"
import {
  iIdParams,
  iInspectorProps,
  iResponse,
} from "../../../definitions/interfaces"
import { iUser } from "../../../definitions/User"
import { get, handleUpdateData } from "../../../store/data/actions"
import UserHeader from "../Header"
import UserAdministration from "./Administration"
import UserProfile from "./Profile"
import UserSubscription from "./Subscription"

const UserInspector: FunctionComponent<iInspectorProps<iUser>> = ({
  item,
  reload,
}) => {
  const [isLoading, setLoading] = useState(false)
  const match = useRouteMatch<iIdParams>()
  const history = useHistory()

  const methods = useForm<iUser>({
    shouldUnregister: false,
  })

  const {
    formState: { dirtyFields },
  } = methods

  useEffect(() => {
    methods.reset({ ...item })
  }, [item])

  const onSubmit = (data: iUser) => {
    setLoading(true)
    handleUpdateData<iUser>({
      data,
      fields: dirtyFields as Partial<iUser>,
      link: "/v2/users/",
    })
      .then(() => {
        reload()
        setLoading(false)
        store.addNotification({
          title: "Success!",
          message: "Exhibition successfully updated!",
          // message: "teodosii@react-notifications-component",
          type: "success",
          ...notificationOptions,
        })
      })
      .catch((e) => {
        if (e) {
          if (e.reason === "Nothing changed!") {
            store.addNotification({
              message: e.reason,
              type: "warning",
              ...notificationOptions,
            })
          } else {
            store.addNotification({
              message: e.reason,
              type: "danger",
              ...notificationOptions,
            })
          }
        } else {
          store.addNotification({
            message: "Something went wrong!",
            type: "danger",
            ...notificationOptions,
          })
        }
        setLoading(false)
      })
  }

  const invokeSubmit = () => {
    methods.handleSubmit((data) => {
      onSubmit(data as iUser)
    })()
  }
  return (
    <FormProvider {...methods}>
      <Seo title="User Inspector" />
      <UserHeader
        title={`${
          item?.profile?.firstName && item?.profile?.lastName
            ? `${item.profile.firstName} ${item.profile.lastName}`
            : item.emails[0].address
        }`}
        handleSubmit={invokeSubmit}
      />
      <div className="inspector">
        {isLoading ? (
          <Loader />
        ) : (
          <form
            className="inspector-form"
            onSubmit={methods.handleSubmit((data) => {
              onSubmit(data)
            })}
          >
            <Route exact path={match.path}>
              <UserProfile item={item} />
            </Route>
            <Route exact path={match.path + "/administration"}>
              <UserAdministration />
            </Route>
            <Route exact path={match.path + "/subscription"}>
              <UserSubscription />
            </Route>
            <button className="d-none" type="submit">
              Submit
            </button>
          </form>
        )}
      </div>
    </FormProvider>
  )
}

const InspectorLoader: FunctionComponent = () => {
  const [isLoading, setLoading] = useState(true)
  const [item, setItem] = useState<iUser>()
  const match = useRouteMatch<iIdParams>()
  const history = useHistory()

  const loadUser = () => {
    get<iResponse<iUser>>({
      link: "/v2/user/" + match.params._id,
    }).then((result) => {
      setItem(result.data)
      setLoading(false)
    })
  }

  useMemo(() => {
    loadUser()
  }, [])

  return isLoading ? (
    <Loader />
  ) : item ? (
    <UserInspector item={item} reload={loadUser} />
  ) : null
}

export default InspectorLoader
